import VideoPicker from "../picker/VideoPicker";
import CommonStyleEditor from "./CommonStyleEditor";

export default function VideoCellProperties({ cell, onChange }) {

    return (
        <div className="property-section">
            <div className="property-section-title">Video</div>
            <div className="property-row">
                <VideoPicker value={cell.video_uri} onChange={(video) => onChange(cell.cell_id, {video_uri: video, type: cell.type})}/>
            </div>
            <div className="property-row">
                <div className="property-label">Loop</div>
                <input className="property-input property-input-small" type="checkbox" checked={cell.loop || false} onChange={(e) => onChange(cell.cell_id, {loop: e.target.checked, type: cell.type})}/>
            </div>
            <div className="property-row">
                <div className="property-label">Autoplay</div>
                <input className="property-input property-input-small" type="checkbox" checked={cell.autoplay || false} onChange={(e) => onChange(cell.cell_id, {autoplay: e.target.checked, type: cell.type})}/>
            </div>
            <div className="property-row">
                <div className="property-label">Controls</div>
                <input className="property-input property-input-small" type="checkbox" checked={cell.controls !== false} onChange={(e) => onChange(cell.cell_id, {controls: e.target.checked, type: cell.type})}/>
            </div>
            <div className="property-row">
                <div className="property-label">Muted</div>
                <input className="property-input property-input-small" type="checkbox" checked={cell.muted !== false} onChange={(e) => onChange(cell.cell_id, {muted: e.target.checked, type: cell.type})}/>
            </div>
            <div className="property-row">
                <div className="property-label">Object fit</div>
                <select className="property-input property-input-small" value={cell.object_fit} onChange={(e) => onChange(cell.cell_id, {object_fit: e.target.value, type: cell.type})}>
                    <option value="cover">Cover</option>
                    <option value="contain">Contain</option>
                    <option value="fill">Fill</option>
                </select>
            </div>
            <CommonStyleEditor cell={cell} onChange={onChange}/>
        </div>
    )
}